<template>
  <router-view v-slot="{ Component }">
    <keep-alive include="Home">
      <component :is="Component" />
    </keep-alive>
  </router-view>
  <div id="appRoot" class="z-50 relative" />
  <l-dialog-wrapper />
  <l-notification-wrapper />
  <manager-confirmation-wrapper />
  <cash-machine-wrapper />
  <update-modal-wrapper />
  <toast-wrapper />
</template>

<script setup lang="ts">
import { LDialogWrapper, LNotificationWrapper } from '@last/core-ui/paprika'

import CashMachineWrapper from '@/plugins/CashMachineWrapper.vue'
import ManagerConfirmationWrapper from '@/plugins/ManagerConfirmationWrapper.vue'
import ToastWrapper from '@/plugins/toast/ToastWrapper.vue'
import UpdateModalWrapper from '@/plugins/UpdateVersionWrapper.vue'
</script>
